import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import { getOfficeTotalThisYearApi } from '@/api/energy';
import OverviewDemand from './OverviewDemand.vue';
import OverviewGreenPower from './OverviewGreenPower.vue';
import OverviewPowerGeneration from './OverviewPowerGeneration.vue';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
var list = ['桃園辦公室用電', '台北辦公室用電', '台中辦公室用電', '高雄辦公室用電'];
export default {
  name: 'EnergyOverview',
  components: {
    OverviewDemand: OverviewDemand,
    OverviewGreenPower: OverviewGreenPower,
    OverviewPowerGeneration: OverviewPowerGeneration
  },
  data: function data() {
    return {
      selectedTab: '用電',
      tabs: ['用電', '綠電', '發電用電'],
      selectedFieldName: '',
      hasSearchFieldName: '',
      // 使用者刪除 selectedFieldName, 將其設定回去
      officeTotalThisYear: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState(['userDetail'])), mapState('projectEnergy', ['lastUpdateTime'])), mapGetters('projectEnergy', ['getFieldNameList'])), {}, {
    currentTabComponent: function currentTabComponent() {
      switch (this.selectedTab) {
        case '用電':
          return 'OverviewDemand';
        case '綠電':
          return 'OverviewGreenPower';
        case '發電用電':
          return 'OverviewPowerGeneration';
        default:
          return 'OverviewDemand';
      }
    },
    titleTooltip: function titleTooltip() {
      if (list.includes(this.selectedFieldName) && this.officeTotalThisYear && this.selectedTab === '用電') {
        return "<div class=\"p-2\">\u4ECA\u5E74\u5404\u5340\u8FA6\u516C\u5BA4\u7E3D\u7528\u96FB\u91CF<br><span class=\"h5\">".concat(this.officeTotalThisYear, "</span> kWh</div>");
      }
      return '';
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations('projectEnergy', ['SET_SELECTED_FIELD_NAME'])), mapActions('projectEnergy', ['getEnergyAllFieldInfoData'])), {}, {
    setSelectedTab: function setSelectedTab(tab) {
      this.selectedTab = tab;
    },
    setFieldName: function setFieldName(fieldName) {
      this.selectedFieldName = fieldName;
      this.hasSearchFieldName = fieldName;
    },
    handleChangeSite: function handleChangeSite(fieldName) {
      if (!fieldName) {
        this.selectedFieldName = this.hasSearchFieldName;
        return;
      }
      this.setFieldName(fieldName);
      this.SET_SELECTED_FIELD_NAME(fieldName);
    },
    getOfficeTotalThisYear: function getOfficeTotalThisYear() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getOfficeTotalThisYearApi();
              case 3:
                res = _context.sent;
                if (!(!res.data.success || !res.data.data)) {
                  _context.next = 6;
                  break;
                }
                return _context.abrupt("return");
              case 6:
                _this.officeTotalThisYear = Math.round(res.data.data * 100) / 100;
                _context.next = 12;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                console.log('getOfficeTotalThisYearApi error', _context.t0);
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }))();
    }
  }),
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getEnergyAllFieldInfoData();
            case 2:
              _this2.getOfficeTotalThisYear();
              _this2.setFieldName(_this2.getFieldNameList[0]);
              // 群組管理尚未提供設定, 先在這裡設定權限
              // Pendy 僅能看用電頁面
              if (_this2.userDetail.displayName === '總務-Pendy') {
                _this2.tabs = ['用電'];
              }
              _this2.setSelectedTab(_this2.tabs[0]);
            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};